export default {"src":"/_next/static/media/infoTooltip.843143ac.svg","height":23,"width":23};